export default "/fonts/PublicSans-ExtraLight.ttf?b40a55af77b1f21d5629c7ec23991b69";